import React from 'react';
import { langColor } from '../utils/github';
import './LanguageChart.css';

export default function LanguageChart({ langs }) {
  if (!langs.length) return null;
  const max = langs[0].count;

  return (
    <div className="langchart card">
      <div className="card__label">Stack breakdown</div>
      <div className="langchart__list">
        {langs.map((l, i) => (
          <div className="langchart__row" key={l.name} style={{ animationDelay: `${i * 60}ms` }}>
            <div className="langchart__meta">
              <span
                className="langchart__dot"
                style={{ background: langColor(l.name) }}
              />
              <span className="langchart__name">{l.name}</span>
              <span className="langchart__count">{l.count} repo{l.count !== 1 ? 's' : ''}</span>
            </div>
            <div className="langchart__bar-bg">
              <div
                className="langchart__bar"
                style={{
                  width: `${(l.count / max) * 100}%`,
                  background: langColor(l.name),
                  animationDelay: `${i * 60 + 200}ms`,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
